import { DateFns } from 'lang-utils'
import lodash from 'lodash'
import {
    MatrizOrFilial,
    MultipleStringKeywordFilter,
    NumberOperator,
    SelectFilter,
    SituacaoCadastral,
    type DateRange,
    type EmpresaCodeFilter,
    type EmpresaFilter,
    type GeoLocation,
    type LocalizacaoFilter,
    type NumberFilter,
    type StringFilter,
    type StringKeywordFilter,
    type TipoAtividadeEconomicaCodeFilter,
    type TipoAtividadeEconomicaTextFilter
} from './tcm_service'

export { type NumberFilter, type StringFilter, type StringKeywordFilter, type TipoAtividadeEconomicaTextFilter }

const fns = DateFns.singleton

export default class FilterManager {
    private __dataDeCorte = new Date()
    readonly serMatrizOrFilial = new ValueProperty<MatrizOrFilial>(this)

    readonly situacaoCadastral = new ValueProperty<SituacaoCadastral>(this)

    readonly localizacaoCircles = new ObjectProperty<GeoLocation[]>(this, true)
    readonly localizacaoRoutes = new ObjectProperty<GeoLocation[]>(this, true)
    readonly localizacaoPolygons = new ObjectProperty<GeoLocation[]>(this, true)
    readonly localizacaoUfs = new ObjectProperty<string[]>(this, true)

    readonly novasUltimoMes = new NovasUltimoMesProperty(this, () => this.__dataDeCorte)

    readonly empresaRazaoSocial = new ValueProperty<StringFilter>(this)
    readonly empresaNomeFantasia = new ValueProperty<StringFilter>(this)
    readonly empresaNomeMatriz = new ValueProperty<StringFilter>(this)
    readonly empresaCodigo = new ValueProperty<EmpresaCodeFilter>(this)
    readonly empresaCnpjMatriz = new ValueProperty<EmpresaCodeFilter>(this)
    readonly empresaCnpjGrupo = new ValueProperty<EmpresaCodeFilter>(this)

    readonly socioKey = new ValueProperty<StringKeywordFilter>(this)
    readonly socioCodigo = new ValueProperty<StringKeywordFilter>(this)
    readonly socioNome = new ValueProperty<StringFilter>(this)

    readonly prfCodigo = new ValueProperty<StringKeywordFilter>(this)
    readonly prfNome = new ValueProperty<StringFilter>(this)

    readonly pesCodigo = new ValueProperty<StringKeywordFilter>(this)
    readonly pesNome = new ValueProperty<StringFilter>(this)

    readonly naturezaJuridicaCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly naturezaJuridicaTexts = new ValueProperty<StringFilter>(this)
    readonly naturezaJuridicaCodeList = new ValueProperty<MultipleStringKeywordFilter>(this)

    readonly atividadeEconomicaCodes = new ValueProperty<StringKeywordFilter>(this)
    readonly atividadeEconomicaTexts = new ValueProperty<StringFilter>(this)
    readonly naturezaJuridicaGrupoCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly naturezaJuridicaPublicaPrivadaCodes = new ObjectProperty<SelectFilter>(this)
    readonly tipoAtividadeEconomicaCodes = new ValueProperty<TipoAtividadeEconomicaCodeFilter>(this)
    readonly tipoAtividadeEconomicaTexts = new ValueProperty<TipoAtividadeEconomicaTextFilter>(this)

    readonly tipoEstabelecimentoSaudeCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly porteEstabelecimentoSaudeCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly cnaeClasseCodes = new ValueProperty<TipoAtividadeEconomicaCodeFilter>(this)
    readonly cnaeClasseTexts = new ValueProperty<TipoAtividadeEconomicaTextFilter>(this)
    readonly cnaeDivisaoCodes = new ValueProperty<TipoAtividadeEconomicaCodeFilter>(this)
    readonly cnaeDivisaoTexts = new ValueProperty<TipoAtividadeEconomicaTextFilter>(this)
    readonly cnaeGrupoCodes = new ValueProperty<TipoAtividadeEconomicaCodeFilter>(this)
    readonly cnaeGrupoTexts = new ValueProperty<TipoAtividadeEconomicaTextFilter>(this)
    readonly cnaeSecaoCodes = new ValueProperty<TipoAtividadeEconomicaCodeFilter>(this)
    readonly cnaeSecaoTexts = new ValueProperty<TipoAtividadeEconomicaTextFilter>(this)
    readonly cnaeSetorCods = new ValueProperty<MultipleStringKeywordFilter>(this)

    readonly empresaCnes = new ValueProperty<StringKeywordFilter>(this)
    readonly scoreRiscos = new ValueProperty<MultipleStringKeywordFilter>(this)

    readonly empresaGrupoCodes = new ValueProperty<StringKeywordFilter>(this)

    readonly enderecoCodes = new ValueProperty<StringKeywordFilter>(this)
    readonly enderecoTexts = new ValueProperty<StringFilter>(this)

    readonly enderecoRuaCodes = new ValueProperty<StringKeywordFilter>(this)
    readonly enderecoRuaTexts = new ValueProperty<StringFilter>(this)

    readonly enderecoBairroCodes = new ValueProperty<StringKeywordFilter>(this)
    readonly enderecoBairroTexts = new ValueProperty<StringFilter>(this)

    readonly enderecoCidadeCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly enderecoCidadeTexts = new ValueProperty<StringFilter>(this)

    readonly cboCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly cboTexts = new ValueProperty<StringFilter>(this)
    readonly cboCategorias = new ValueProperty<MultipleStringKeywordFilter>(this)

    readonly pesCboCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly pesCboTexts = new ValueProperty<StringFilter>(this)
    readonly pesCboCategorias = new ValueProperty<MultipleStringKeywordFilter>(this)

    readonly enderecoUfs = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly enderecoUfTexts = new ValueProperty<StringFilter>(this)

    readonly enderecoCeps = new ValueProperty<StringKeywordFilter>(this)
    readonly enderecoCepTexts = new ValueProperty<StringFilter>(this)

    readonly enderecoRegiaoMetropolitanaCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly enderecoRegiaoMetropolitanaTexts = new ValueProperty<StringFilter>(this)

    readonly inicioAtividade = new ObjectProperty<DateRange>(this)
    readonly dtSituacaoCadastral = new ObjectProperty<DateRange>(this)
    readonly dtCompetenciaInicioAtividade = new ObjectProperty<DateRange>(this)
    readonly totalEmpresasNoGrupo = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly idadeEmpresaEmAnos = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly capitalSocial = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios_0_a_18 = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios_19_a_33 = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios_34_a_48 = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios_49_a_58 = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionarios_59_ou_mais = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionariosFemininos = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionariosMasculinos = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionariosDoGrupo = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly percentualFuncionariasMulheres = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly faturamentoEstimado = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly faturamentoEstimadoGrupo = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly matrizFilial = new ObjectProperty<SelectFilter>(this)
    readonly regimeTributario = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly porteReceitaFederal = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly regiaoGeograficaImediataCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly regiaoGeograficaIntermediariaCodes = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly portePorFuncionarios = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly portePorFaturamentoEstimadoCnpj = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly portePorFaturamentoEstimadoGrupo = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly cadeiaValorSaude = new ObjectProperty<SelectFilter>(this)

    // colunas da listagem de empresas que não tinham filtro
    readonly matrizUfs = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly enderecoNumeros = new ValueProperty<StringKeywordFilter>(this)
    readonly enderecoComplementoTexts = new ValueProperty<StringFilter>(this)
    readonly enderecoLatitude = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly enderecoLongitude = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly telefone1 = new ValueProperty<StringFilter>(this)
    readonly telefone2 = new ValueProperty<StringFilter>(this)
    readonly email = new ValueProperty<StringFilter>(this)
    readonly totalFiliais = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly totalFuncionariosMatrizEFiliais = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly salarioTotal = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly salarioTotalGrupo = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly optanteSimples = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly optanteMei = new ValueProperty<MultipleStringKeywordFilter>(this)
    readonly webNomeTexts = new ValueProperty<StringFilter>(this)
    readonly webCategoriasTexts = new ValueProperty<StringFilter>(this)
    readonly webNota = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly webQtdAvaliacoes = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly webTempoMedio = new ObjectProperty<NumberFilter>(this, false, NumberFilterToKey, true)
    readonly webSite = new ValueProperty<StringFilter>(this)
    readonly webTelefone = new ValueProperty<StringFilter>(this)

    enchenteRs2024 = false

    private __isAdditiveModeOn = () => false

    // prettier-ignore
    public build() {
        const tgt: EmpresaFilter = {}

        const localizacaoFilter: LocalizacaoFilter ={}
        {
            let hasFilter = false
            this.localizacaoCircles.size > 0 && (hasFilter = true, localizacaoFilter.circles = [...this.localizacaoCircles.values()])
            this.localizacaoRoutes.size > 0 && (hasFilter = true, localizacaoFilter.routes = [...this.localizacaoRoutes.values()])
            this.localizacaoPolygons.size > 0 && (hasFilter = true, localizacaoFilter.polygons = [...this.localizacaoPolygons.values()])
            this.localizacaoUfs.size > 0 && (hasFilter = true, localizacaoFilter.ufs = [...this.localizacaoUfs.values()])
            if (hasFilter) {
                localizacaoFilter.size = 3_000
                tgt.localizacao = localizacaoFilter
            }
        }

        this.situacaoCadastral.size > 0 && (tgt.situacaoCadastral = [...this.situacaoCadastral.values()])
        this.serMatrizOrFilial.size > 0 && (tgt.matrizOrFilial = [...this.serMatrizOrFilial.values()])
        this.empresaRazaoSocial.size > 0 && (tgt.empresaRazaoSocial = [...this.empresaRazaoSocial.values()])
        this.empresaNomeFantasia.size > 0 && (tgt.empresaNomeFantasia = [...this.empresaNomeFantasia.values()])
        this.empresaNomeMatriz.size > 0 && (tgt.empresaNomeMatriz = [...this.empresaNomeMatriz.values()])
        this.empresaCodigo.size > 0 && (tgt.empresaCodigo = [...this.empresaCodigo.values()])
        this.empresaCnpjMatriz.size > 0 && (tgt.empresaCnpjMatriz = [...this.empresaCnpjMatriz.values()])
        this.empresaCnpjGrupo.size > 0 && (tgt.empresaCnpjGrupo = [...this.empresaCnpjGrupo.values()])
        
        this.atividadeEconomicaCodes.size > 0 && (tgt.atividadeEconomicaCodes = [...this.atividadeEconomicaCodes.values()])
        this.atividadeEconomicaTexts.size > 0 && (tgt.atividadeEconomicaTexts = [...this.atividadeEconomicaTexts.values()])
        this.naturezaJuridicaGrupoCodes.size > 0 && (tgt.naturezaJuridicaGrupoCodes = [...this.naturezaJuridicaGrupoCodes.values()])
        this.naturezaJuridicaPublicaPrivadaCodes.size > 0 && (tgt.naturezaJuridicaPublicaPrivadaCodes = [...this.naturezaJuridicaPublicaPrivadaCodes.values()])
        this.tipoAtividadeEconomicaCodes.size > 0 && (tgt.tipoAtividadeEconomicaCodes = [...this.tipoAtividadeEconomicaCodes.values()])
        this.tipoAtividadeEconomicaTexts.size > 0 && (tgt.tipoAtividadeEconomicaTexts = [...this.tipoAtividadeEconomicaTexts.values()])
        this.tipoEstabelecimentoSaudeCodes.size > 0 && (tgt.tipoEstabelecimentoSaudeCodes = [...this.tipoEstabelecimentoSaudeCodes.values()])
        this.porteEstabelecimentoSaudeCodes.size > 0 && (tgt.porteEstabelecimentoSaudeCodes = [...this.porteEstabelecimentoSaudeCodes.values()])
        this.cnaeClasseCodes.size > 0 && (tgt.cnaeClasseCodes = [...this.cnaeClasseCodes.values()])
        this.cnaeClasseTexts.size > 0 && (tgt.cnaeClasseTexts = [...this.cnaeClasseTexts.values()])
        this.cnaeDivisaoCodes.size > 0 && (tgt.cnaeDivisaoCodes = [...this.cnaeDivisaoCodes.values()])
        this.cnaeDivisaoTexts.size > 0 && (tgt.cnaeDivisaoTexts = [...this.cnaeDivisaoTexts.values()])
        this.cnaeGrupoCodes.size > 0 && (tgt.cnaeGrupoCodes = [...this.cnaeGrupoCodes.values()])
        this.cnaeGrupoTexts.size > 0 && (tgt.cnaeGrupoTexts = [...this.cnaeGrupoTexts.values()])
        this.cnaeSecaoCodes.size > 0 && (tgt.cnaeSecaoCodes = [...this.cnaeSecaoCodes.values()])
        this.cnaeSecaoTexts.size > 0 && (tgt.cnaeSecaoTexts = [...this.cnaeSecaoTexts.values()])
        this.cnaeSetorCods.size > 0 && (tgt.cnaeSetorCods = [...this.cnaeSetorCods.values()])

        this.scoreRiscos.size > 0 && (tgt.scoreRiscos = [...this.scoreRiscos.values()])

        this.empresaGrupoCodes.size > 0 && (tgt.empresaGrupoCodes = [...this.empresaGrupoCodes.values()])
        this.empresaCnes.size > 0 && (tgt.empresaCnes = [...this.empresaCnes.values()])
        this.enderecoTexts.size > 0 && (tgt.enderecoTexts = [...this.enderecoTexts.values()])
        this.enderecoCodes.size > 0 && (tgt.enderecoCodes = [...this.enderecoCodes.values()])
        this.enderecoRuaTexts.size > 0 && (tgt.enderecoRuaTexts = [...this.enderecoRuaTexts.values()])
        this.enderecoRuaCodes.size > 0 && (tgt.enderecoRuaCodes = [...this.enderecoRuaCodes.values()])
        this.enderecoBairroTexts.size > 0 && (tgt.enderecoBairroTexts = [...this.enderecoBairroTexts.values()])
        this.enderecoBairroCodes.size > 0 && (tgt.enderecoBairroCodes = [...this.enderecoBairroCodes.values()])
        this.enderecoCidadeTexts.size > 0 && (tgt.enderecoCidadeTexts = [...this.enderecoCidadeTexts.values()])
        this.enderecoCidadeCodes.size > 0 && (tgt.enderecoCidadeCodes = [...this.enderecoCidadeCodes.values()])
        
        this.cboCodes.size > 0 && (tgt.cboCodes = [...this.cboCodes.values()])
        this.cboTexts.size > 0 && (tgt.cboTexts = [...this.cboTexts.values()])
        this.cboCategorias.size > 0 && (tgt.cboCategorias = [...this.cboCategorias.values()])

        this.pesCboCodes.size > 0 && (tgt.pesCboCodes = [...this.pesCboCodes.values()])
        this.pesCboTexts.size > 0 && (tgt.pesCboTexts = [...this.pesCboTexts.values()])
        this.pesCboCategorias.size > 0 && (tgt.pesCboCategorias = [...this.pesCboCategorias.values()])

        this.enderecoUfs.size > 0 && (tgt.enderecoUfs = [...this.enderecoUfs.values()])
        this.enderecoUfTexts.size > 0 && (tgt.enderecoUfTexts = [...this.enderecoUfTexts.values()])

        this.enderecoCepTexts.size > 0 && (tgt.enderecoCepTexts = [...this.enderecoCepTexts.values()])
        this.enderecoCeps.size > 0 && (tgt.enderecoCeps = [...this.enderecoCeps.values()])
        this.enderecoRegiaoMetropolitanaTexts.size > 0 && (tgt.enderecoRegiaoMetropolitanaTexts = [...this.enderecoRegiaoMetropolitanaTexts.values()])
        this.enderecoRegiaoMetropolitanaCodes.size > 0 && (tgt.enderecoRegiaoMetropolitanaCodes = [...this.enderecoRegiaoMetropolitanaCodes.values()])
        this.naturezaJuridicaTexts.size > 0 && (tgt.naturezaJuridicaTexts = [...this.naturezaJuridicaTexts.values()])
        this.naturezaJuridicaCodeList.size > 0 && (tgt.naturezaJuridicaCodeList = [...this.naturezaJuridicaCodeList.values()])
        this.naturezaJuridicaCodes.size > 0 && (tgt.naturezaJuridicaCodes = [...this.naturezaJuridicaCodes.values()])
        this.inicioAtividade.size > 0 && (tgt.inicioAtividade = [...this.inicioAtividade.values()])
        this.dtSituacaoCadastral.size > 0 && (tgt.dtSituacaoCadastral = [...this.dtSituacaoCadastral.values()])
        this.dtCompetenciaInicioAtividade.size > 0 && (tgt.dtCompetenciaInicioAtividade = [...this.dtCompetenciaInicioAtividade.values()])
        this.idadeEmpresaEmAnos.size > 0 && (tgt.idadeEmpresaEmAnos = [...this.idadeEmpresaEmAnos.values()])
        this.totalEmpresasNoGrupo.size > 0 && (tgt.totalEmpresasNoGrupo = [...this.totalEmpresasNoGrupo.values()])
        this.capitalSocial.size > 0 && (tgt.capitalSocial = [...this.capitalSocial.values()])
        this.totalFuncionarios.size > 0 && (tgt.totalFuncionarios = [...this.totalFuncionarios.values()])
        this.totalFuncionarios_0_a_18.size > 0 && (tgt.totalFuncionarios_0_a_18 = [...this.totalFuncionarios_0_a_18.values()])
        this.totalFuncionarios_19_a_33.size > 0 && (tgt.totalFuncionarios_19_a_33 = [...this.totalFuncionarios_19_a_33.values()])
        this.totalFuncionarios_34_a_48.size > 0 && (tgt.totalFuncionarios_34_a_48 = [...this.totalFuncionarios_34_a_48.values()])
        this.totalFuncionarios_49_a_58.size > 0 && (tgt.totalFuncionarios_49_a_58 = [...this.totalFuncionarios_49_a_58.values()])
        this.totalFuncionarios_59_ou_mais.size > 0 && (tgt.totalFuncionarios_59_ou_mais = [...this.totalFuncionarios_59_ou_mais.values()])
        this.totalFuncionariosFemininos.size > 0 && (tgt.totalFuncionariosFemininos = [...this.totalFuncionariosFemininos.values()])
        this.totalFuncionariosMasculinos.size > 0 && (tgt.totalFuncionariosMasculinos = [...this.totalFuncionariosMasculinos.values()])
        this.totalFuncionariosDoGrupo.size > 0 && (tgt.totalFuncionariosDoGrupo = [...this.totalFuncionariosDoGrupo.values()])
        this.percentualFuncionariasMulheres.size > 0 && (tgt.percentualFuncionariasMulheres = [...this.percentualFuncionariasMulheres.values()])
        this.faturamentoEstimado.size > 0 && (tgt.faturamentoEstimado = [...this.faturamentoEstimado.values()])
        this.faturamentoEstimadoGrupo.size > 0 && (tgt.faturamentoEstimadoGrupo = [...this.faturamentoEstimadoGrupo.values()])
        this.matrizFilial.size > 0 && (tgt.matrizFilial = [...this.matrizFilial.values()])
        this.regimeTributario.size > 0 && (tgt.regimeTributario = [...this.regimeTributario.values()])
        this.porteReceitaFederal.size > 0 && (tgt.porteReceitaFederal = [...this.porteReceitaFederal.values()])
        this.regiaoGeograficaImediataCodes.size > 0 && (tgt.regiaoGeograficaImediataCodes = [...this.regiaoGeograficaImediataCodes.values()])
        this.regiaoGeograficaIntermediariaCodes.size > 0 && (tgt.regiaoGeograficaIntermediariaCodes = [...this.regiaoGeograficaIntermediariaCodes.values()])
        this.portePorFuncionarios.size > 0 && (tgt.portePorFuncionarios = [...this.portePorFuncionarios.values()])
        this.portePorFaturamentoEstimadoCnpj.size > 0 && (tgt.portePorFaturamentoEstimadoCnpj = [...this.portePorFaturamentoEstimadoCnpj.values()])
        this.portePorFaturamentoEstimadoGrupo.size > 0 && (tgt.portePorFaturamentoEstimadoGrupo = [...this.portePorFaturamentoEstimadoGrupo.values()])
        this.cadeiaValorSaude.size > 0 && (tgt.cadeiaValorSaude = [...this.cadeiaValorSaude.values()])
        this.matrizUfs.size > 0 && (tgt.matrizUfs = [...this.matrizUfs.values()])
        this.enderecoNumeros.size > 0 && (tgt.enderecoNumeros = [...this.enderecoNumeros.values()])
        this.enderecoComplementoTexts.size > 0 && (tgt.enderecoComplementoTexts = [...this.enderecoComplementoTexts.values()])
        this.enderecoLatitude.size > 0 && (tgt.enderecoLatitude = [...this.enderecoLatitude.values()])
        this.enderecoLongitude.size > 0 && (tgt.enderecoLongitude = [...this.enderecoLongitude.values()])
        this.telefone1.size > 0 && (tgt.telefone1 = [...this.telefone1.values()])
        this.telefone2.size > 0 && (tgt.telefone2 = [...this.telefone2.values()])
        this.email.size > 0 && (tgt.email = [...this.email.values()])
        this.totalFiliais.size > 0 && (tgt.totalFiliais = [...this.totalFiliais.values()])
        this.totalFuncionariosMatrizEFiliais.size > 0 && (tgt.totalFuncionariosMatrizEFiliais = [...this.totalFuncionariosMatrizEFiliais.values()])
        this.salarioTotal.size > 0 && (tgt.salarioTotal = [...this.salarioTotal.values()])
        this.salarioTotalGrupo.size > 0 && (tgt.salarioTotalGrupo = [...this.salarioTotalGrupo.values()])
        this.optanteSimples.size > 0 && (tgt.optanteSimples = [...this.optanteSimples.values()])
        this.optanteMei.size > 0 && (tgt.optanteMei = [...this.optanteMei.values()])
        this.webNomeTexts.size > 0 && (tgt.webNomeTexts = [...this.webNomeTexts.values()])
        this.webCategoriasTexts.size > 0 && (tgt.webCategoriasTexts = [...this.webCategoriasTexts.values()])
        this.webNota.size > 0 && (tgt.webNota = [...this.webNota.values()])
        this.webQtdAvaliacoes.size > 0 && (tgt.webQtdAvaliacoes = [...this.webQtdAvaliacoes.values()])
        this.webTempoMedio.size > 0 && (tgt.webTempoMedio = [...this.webTempoMedio.values()])
        this.webSite.size > 0 && (tgt.webSite = [...this.webSite.values()])
        this.webTelefone.size > 0 && (tgt.webTelefone = [...this.webTelefone.values()])

        this.socioCodigo.size > 0 && (tgt.socioCodigo = [...this.socioCodigo.values()])
        this.socioKey.size > 0 && (tgt.socioKey = [...this.socioKey.values()])
        this.socioNome.size > 0 && (tgt.socioNome = [...this.socioNome.values()])

        this.prfCodigo.size > 0 && (tgt.prfCodigo = [...this.prfCodigo.values()])
        this.prfNome.size > 0 && (tgt.prfNome = [...this.prfNome.values()])

        this.pesCodigo.size > 0 && (tgt.pesCodigo = [...this.pesCodigo.values()])
        this.pesNome.size > 0 && (tgt.pesNome = [...this.pesNome.values()])

        this.enchenteRs2024 && (tgt.enchenteRs2024 = true)

        return tgt
    }

    hasFilter() {
        return (
            this.serMatrizOrFilial.size > 0 ||
            this.situacaoCadastral.size > 0 ||
            this.localizacaoCircles.size > 0 ||
            this.localizacaoRoutes.size > 0 ||
            this.localizacaoPolygons.size > 0 ||
            this.localizacaoUfs.size > 0 ||
            this.novasUltimoMes.size > 0 ||
            this.empresaRazaoSocial.size > 0 ||
            this.empresaNomeFantasia.size > 0 ||
            this.empresaNomeMatriz.size > 0 ||
            this.empresaCodigo.size > 0 ||
            this.empresaCnpjMatriz.size > 0 ||
            this.empresaCnpjGrupo.size > 0 ||
            this.socioKey.size > 0 ||
            this.socioCodigo.size > 0 ||
            this.socioNome.size > 0 ||
            this.prfCodigo.size > 0 ||
            this.prfNome.size > 0 ||
            this.pesCodigo.size > 0 ||
            this.pesNome.size > 0 ||
            this.naturezaJuridicaCodes.size > 0 ||
            this.naturezaJuridicaTexts.size > 0 ||
            this.naturezaJuridicaCodeList.size > 0 ||
            this.atividadeEconomicaCodes.size > 0 ||
            this.atividadeEconomicaTexts.size > 0 ||
            this.naturezaJuridicaGrupoCodes.size > 0 ||
            this.naturezaJuridicaPublicaPrivadaCodes.size > 0 ||
            this.tipoAtividadeEconomicaCodes.size > 0 ||
            this.tipoAtividadeEconomicaTexts.size > 0 ||
            this.tipoEstabelecimentoSaudeCodes.size > 0 ||
            this.porteEstabelecimentoSaudeCodes.size > 0 ||
            this.cnaeClasseCodes.size > 0 ||
            this.cnaeClasseTexts.size > 0 ||
            this.cnaeDivisaoCodes.size > 0 ||
            this.cnaeDivisaoTexts.size > 0 ||
            this.cnaeGrupoCodes.size > 0 ||
            this.cnaeGrupoTexts.size > 0 ||
            this.cnaeSecaoCodes.size > 0 ||
            this.cnaeSecaoTexts.size > 0 ||
            this.cnaeSetorCods.size > 0 ||
            this.empresaCnes.size > 0 ||
            this.scoreRiscos.size > 0 ||
            this.empresaGrupoCodes.size > 0 ||
            this.enderecoCodes.size > 0 ||
            this.enderecoTexts.size > 0 ||
            this.enderecoRuaCodes.size > 0 ||
            this.enderecoRuaTexts.size > 0 ||
            this.enderecoBairroCodes.size > 0 ||
            this.enderecoBairroTexts.size > 0 ||
            this.enderecoCidadeCodes.size > 0 ||
            this.enderecoCidadeTexts.size > 0 ||
            this.cboCodes.size > 0 ||
            this.cboTexts.size > 0 ||
            this.cboCategorias.size > 0 ||
            this.pesCboCodes.size > 0 ||
            this.pesCboTexts.size > 0 ||
            this.pesCboCategorias.size > 0 ||
            this.enderecoUfs.size > 0 ||
            this.enderecoUfTexts.size > 0 ||
            this.enderecoCeps.size > 0 ||
            this.enderecoCepTexts.size > 0 ||
            this.enderecoRegiaoMetropolitanaCodes.size > 0 ||
            this.enderecoRegiaoMetropolitanaTexts.size > 0 ||
            this.inicioAtividade.size > 0 ||
            this.dtSituacaoCadastral.size > 0 ||
            this.dtCompetenciaInicioAtividade.size > 0 ||
            this.totalEmpresasNoGrupo.size > 0 ||
            this.idadeEmpresaEmAnos.size > 0 ||
            this.capitalSocial.size > 0 ||
            this.totalFuncionarios.size > 0 ||
            this.totalFuncionarios_0_a_18.size > 0 ||
            this.totalFuncionarios_19_a_33.size > 0 ||
            this.totalFuncionarios_34_a_48.size > 0 ||
            this.totalFuncionarios_49_a_58.size > 0 ||
            this.totalFuncionarios_59_ou_mais.size > 0 ||
            this.totalFuncionariosFemininos.size > 0 ||
            this.totalFuncionariosMasculinos.size > 0 ||
            this.totalFuncionariosDoGrupo.size > 0 ||
            this.percentualFuncionariasMulheres.size > 0 ||
            this.faturamentoEstimado.size > 0 ||
            this.faturamentoEstimadoGrupo.size > 0 ||
            this.matrizFilial.size > 0 ||
            this.regimeTributario.size > 0 ||
            this.porteReceitaFederal.size > 0 ||
            this.regiaoGeograficaImediataCodes.size > 0 ||
            this.regiaoGeograficaIntermediariaCodes.size > 0 ||
            this.portePorFuncionarios.size > 0 ||
            this.portePorFaturamentoEstimadoCnpj.size > 0 ||
            this.portePorFaturamentoEstimadoGrupo.size > 0 ||
            this.cadeiaValorSaude.size > 0 ||
            this.matrizUfs.size > 0 ||
            this.enderecoNumeros.size > 0 ||
            this.enderecoComplementoTexts.size > 0 ||
            this.enderecoLatitude.size > 0 ||
            this.enderecoLongitude.size > 0 ||
            this.telefone1.size > 0 ||
            this.telefone2.size > 0 ||
            this.email.size > 0 ||
            this.totalFiliais.size > 0 ||
            this.totalFuncionariosMatrizEFiliais.size > 0 ||
            this.salarioTotal.size > 0 ||
            this.salarioTotalGrupo.size > 0 ||
            this.optanteSimples.size > 0 ||
            this.optanteMei.size > 0 ||
            this.webNomeTexts.size > 0 ||
            this.webCategoriasTexts.size > 0 ||
            this.webNota.size > 0 ||
            this.webQtdAvaliacoes.size > 0 ||
            this.webTempoMedio.size > 0 ||
            this.webSite.size > 0 ||
            this.webTelefone.size > 0 ||
            this.enchenteRs2024
        )
    }

    bindIsAdditiveModeOn(listener: () => boolean) {
        this.__isAdditiveModeOn = listener
    }

    isInAdditiveMode() {
        return this.__isAdditiveModeOn()
    }

    setDataDeCorte(date: Date) {
        this.__dataDeCorte = date
    }

    clear() {
        this.serMatrizOrFilial.clear()
        this.situacaoCadastral.clear()
        this.novasUltimoMes.clear()
        this.localizacaoCircles.clear()
        this.localizacaoRoutes.clear()
        this.localizacaoPolygons.clear()
        this.localizacaoUfs.clear()
        this.empresaRazaoSocial.clear()
        this.empresaNomeFantasia.clear()
        this.empresaNomeMatriz.clear()
        this.empresaCodigo.clear()
        this.empresaGrupoCodes.clear()
        this.empresaCnes.clear()
        this.atividadeEconomicaCodes.clear()
        this.atividadeEconomicaTexts.clear()
        this.naturezaJuridicaGrupoCodes.clear()
        this.naturezaJuridicaPublicaPrivadaCodes.clear()
        this.tipoAtividadeEconomicaCodes.clear()
        this.tipoAtividadeEconomicaTexts.clear()
        this.scoreRiscos.clear()
        this.enderecoTexts.clear()
        this.enderecoCodes.clear()
        this.enderecoRuaTexts.clear()
        this.enderecoRuaCodes.clear()
        this.enderecoBairroTexts.clear()
        this.enderecoBairroCodes.clear()
        this.enderecoCidadeTexts.clear()
        this.enderecoCidadeCodes.clear()
        this.enderecoUfs.clear()
        this.enderecoUfTexts.clear()
        this.enderecoCepTexts.clear()
        this.enderecoCeps.clear()
        this.enderecoRegiaoMetropolitanaTexts.clear()
        this.enderecoRegiaoMetropolitanaCodes.clear()
        this.cboCodes.clear()
        this.cboTexts.clear()
        this.cboCategorias.clear()
        this.pesCboCodes.clear()
        this.pesCboTexts.clear()
        this.pesCboCategorias.clear()
        this.naturezaJuridicaTexts.clear()
        this.naturezaJuridicaCodeList.clear()
        this.naturezaJuridicaCodes.clear()
        this.inicioAtividade.clear()
        this.idadeEmpresaEmAnos.clear()
        this.capitalSocial.clear()
        this.totalFuncionarios.clear()
        this.totalFuncionarios_0_a_18.clear()
        this.totalFuncionarios_19_a_33.clear()
        this.totalFuncionarios_34_a_48.clear()
        this.totalFuncionarios_49_a_58.clear()
        this.totalFuncionarios_59_ou_mais.clear()
        this.totalFuncionariosFemininos.clear()
        this.totalFuncionariosMasculinos.clear()
        this.totalFuncionariosDoGrupo.clear()
        this.percentualFuncionariasMulheres.clear()
        this.totalEmpresasNoGrupo.clear()
        this.faturamentoEstimado.clear()
        this.faturamentoEstimadoGrupo.clear()
        this.matrizUfs.clear()
        this.enderecoNumeros.clear()
        this.enderecoComplementoTexts.clear()
        this.enderecoLatitude.clear()
        this.enderecoLongitude.clear()
        this.telefone1.clear()
        this.telefone2.clear()
        this.email.clear()
        this.totalFiliais.clear()
        this.totalFuncionariosMatrizEFiliais.clear()
        this.salarioTotal.clear()
        this.salarioTotalGrupo.clear()
        this.optanteSimples.clear()
        this.optanteMei.clear()
        this.webNomeTexts.clear()
        this.webCategoriasTexts.clear()
        this.webNota.clear()
        this.webQtdAvaliacoes.clear()
        this.webTempoMedio.clear()
        this.webSite.clear()
        this.webTelefone.clear()

        this.socioCodigo.clear()
        this.socioKey.clear()
        this.socioNome.clear()
        this.prfCodigo.clear()
        this.prfNome.clear()
        this.pesCodigo.clear()
        this.pesNome.clear()

        this.empresaCnpjMatriz.clear()
        this.empresaCnpjGrupo.clear()
        this.tipoEstabelecimentoSaudeCodes.clear()
        this.porteEstabelecimentoSaudeCodes.clear()
        this.cnaeClasseCodes.clear()
        this.cnaeClasseTexts.clear()
        this.cnaeDivisaoCodes.clear()
        this.cnaeDivisaoTexts.clear()
        this.cnaeGrupoCodes.clear()
        this.cnaeGrupoTexts.clear()
        this.cnaeSecaoCodes.clear()
        this.cnaeSecaoTexts.clear()
        this.cnaeSetorCods.clear()
        this.dtSituacaoCadastral.clear()
        this.dtCompetenciaInicioAtividade.clear()
        this.matrizFilial.clear()
        this.regimeTributario.clear()
        this.porteReceitaFederal.clear()
        this.regiaoGeograficaImediataCodes.clear()
        this.regiaoGeograficaIntermediariaCodes.clear()
        this.portePorFuncionarios.clear()
        this.portePorFaturamentoEstimadoCnpj.clear()
        this.portePorFaturamentoEstimadoGrupo.clear()
        this.cadeiaValorSaude.clear()

        this.enchenteRs2024 = false
    }
}

const FN_TRUE = () => true

export class NovasUltimoMesProperty {
    private readonly __mngr: FilterManager
    private readonly __fnGetDataCorete: () => Date

    constructor(mngr: FilterManager, fnGetDataCorete: () => Date) {
        this.__mngr = mngr
        this.__fnGetDataCorete = fnGetDataCorete
    }

    get selected() {
        const refDate = this.__computeRefDate()
        for (const dateRange of this.__mngr.inicioAtividade.values()) {
            if (dateRange.from === refDate && !dateRange.to) {
                return true
            }
        }
        return false
    }

    clear() {
        this.remove()
    }

    get size() {
        return this.__mngr.inicioAtividade.size
    }

    add() {
        this.__mngr.situacaoCadastral.add(SituacaoCadastral.ativa)
        return this.__mngr.inicioAtividade.add({ from: this.__computeRefDate() })
    }

    remove() {
        this.__mngr.situacaoCadastral.remove(SituacaoCadastral.ativa)
        this.__mngr.inicioAtividade.remove({ from: this.__computeRefDate() })
    }

    private __computeRefDate() {
        const dataDeCorte = this.__fnGetDataCorete()
        return fns().formatISO(fns().subMonths(dataDeCorte, 1))
    }
}

export class ValueProperty<T> {
    private readonly __mngr: FilterManager
    private readonly __valueSet = new Set<T>()

    constructor(mngr: FilterManager) {
        this.__mngr = mngr
    }

    get size() {
        return this.__valueSet.size
    }

    values() {
        return this.__valueSet.values()
    }

    has(value: T | undefined) {
        if (lodash.isNil(value)) {
            return false
        }
        return this.__valueSet.has(value)
    }

    apply(values: T[] | null | undefined) {
        this.clear()

        if (!values || values.length == 0) {
            return
        }

        const oldIsInAdditiveMode = this.__mngr.isInAdditiveMode
        this.__mngr.isInAdditiveMode = FN_TRUE
        try {
            values.forEach((value) => {
                this.add(value)
            })
        } finally {
            this.__mngr.isInAdditiveMode = oldIsInAdditiveMode
        }
    }

    add(value: T | undefined) {
        const additive = this.__mngr.isInAdditiveMode()
        const valueSet = this.__valueSet

        if (additive) {
            if (!lodash.isNil(value)) {
                if (valueSet.has(value)) {
                    valueSet.delete(value)
                    return false
                }
                valueSet.add(value)
                return true
            }
            return false
        }

        if (lodash.isNil(value)) {
            valueSet.clear()
            return false
        }

        if (valueSet.size === 1) {
            if (valueSet.has(value)) {
                valueSet.clear()
                return false
            }
        }

        valueSet.clear()
        valueSet.add(value)
        return true
    }

    remove(value: T | undefined) {
        if (lodash.isNil(value)) {
            return
        }
        this.__valueSet.delete(value)
    }

    clear() {
        this.__valueSet.clear()
    }
}

export class ObjectProperty<T> {
    private readonly __valueMap = new Map<string, T>()
    private readonly __toKey: (v: T) => string
    private readonly __debug
    private __isInAdditiveMode: () => boolean

    constructor(mngr: FilterManager, alwaysAdditive = false, toKey?: (v: T) => string, debug = false) {
        this.__debug = debug
        this.__isInAdditiveMode = alwaysAdditive ? () => true : mngr.isInAdditiveMode.bind(mngr)
        this.__toKey = toKey ? toKey : (v) => JSON.stringify(v)
    }

    get size() {
        return this.__valueMap.size
    }

    toKey(v: T) {
        return this.__toKey(v)
    }

    isEmpty() {
        return this.__valueMap.size === 0
    }

    keys() {
        return this.__valueMap.keys()
    }

    values() {
        return this.__valueMap.values()
    }

    has(value: T | undefined) {
        if (lodash.isNil(value)) {
            return false
        }
        const newKey = this.__toKey(value)
        return this.__valueMap.has(newKey)
    }

    hasKey(key: string) {
        return this.__valueMap.has(key)
    }

    apply(values: T[] | null | undefined) {
        this.clear()

        if (!values || values.length == 0) {
            return
        }

        const oldIsInAdditiveMode = this.__isInAdditiveMode
        this.__isInAdditiveMode = FN_TRUE
        try {
            values.forEach((value) => {
                this.add(value)
            })
        } finally {
            this.__isInAdditiveMode = oldIsInAdditiveMode
        }
    }

    add(value: T | undefined) {
        const additive = this.__isInAdditiveMode()
        const valueMap = this.__valueMap
        if (lodash.isNil(value)) {
            if (!additive) {
                valueMap.clear()
            }
            return false
        }

        const newKey = this.__toKey(value)

        if (additive) {
            if (valueMap.has(newKey)) {
                valueMap.delete(newKey)
                return false
            }

            valueMap.set(newKey, value)
            return true
        } else if (valueMap.has(newKey)) {
            valueMap.delete(newKey)
            return false
        } else {
            valueMap.clear()
            valueMap.set(newKey, value)
            return true
        }
    }

    remove(value: T | undefined) {
        if (this.__debug) {
            console.debug('remove: ' + value)
        }
        if (lodash.isNil(value)) {
            return
        }
        const newKey = this.__toKey(value)
        this.__valueMap.delete(newKey)
    }

    clear() {
        if (this.__debug) {
            console.debug('clear')
        }
        this.__valueMap.clear()
    }
}

export function NumberFilterToKey(filter: NumberFilter) {
    const key = `${filter.mode}-${filter.operator}-${filter.value}`
    if (filter.operator == NumberOperator.in_range || filter.operator == NumberOperator.out_of_range) {
        return `${key}:${filter.to}`
    }
    return key
}
